// extracted by mini-css-extract-plugin
export var bold = "_sp-0";